import { EventCategory } from '@/types/Helper/Enums'

export interface EventDetails {
  id: string
  title: string
  startDate: Date
  endDate: Date
  resources: string[]
  isRecurrent: boolean // Checkbox for recurrence
  recurrenceType: string // daily, weekly, monthly
  recurrenceCount: number // Number of occurrences
  category: EventCategory
}

export function createEventDetails() {
  return {
    id: '',
    title: '',
    startDate: new Date(),
    endDate: new Date(),
    resources: [],
    isRecurrent: false,
    recurrenceType: '',
    recurrenceCount: 1,
    category: EventCategory.flight
  }
}
